import React from 'react'
import PropTypes from 'prop-types'

import Button from '../../Button/Button'
import ButtonSpacer from '../../ButtonSpacer/ButtonSpacer'

import './FulfillmentConfirm.css'

export const FulfillmentConfirm = ({ onClose }) => (
  <React.Fragment>
    <p styleName='text'>
      Changing your order time will remove any items you currently have in your
      cart.
    </p>
    <p styleName='text'>Do you want to continue?</p>
    <Button type='submit' style='primary'>
      Yes, change my order time
    </Button>
    <ButtonSpacer vertical />
    <Button type='button' onClick={onClose} style='linkWide'>
      Cancel
    </Button>
  </React.Fragment>
)

FulfillmentConfirm.propTypes = {
  onClose: PropTypes.func.isRequired
}
